import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";

import {
  AkciznaMarkicaKategorijaProzivoda,
  ExciseStampRequestListPayload,
  IGenerisiZahtevZaMarkicuPdfProps,
  IInformacijeZaVracanjeMarkica,
  IInicijalniPodaciZaZahtevObveznikaProps,
  IKategorijaZaZahtevProps,
  IKreiranjeZahtevaZaMarkicuPayload,
  IMaloProdajnaPayload,
  IMaloProdajnaProps,
  IPodaciOMarkamaProizvodaPayload,
  IPopuniIzvestajZaKafuIliAlkoholPayload,
  IResultsProps,
  IStampajPredracunProps,
  ISviZahteviMarkiceProps,
  IVracanjeDodatnihInformacijaZaKreiranjeZahtevaProps,
  IZahtevMarkiceIdProps,
  MarkicaZahtevIsporuceniOpsezi,
  NapravljenZahtevZaMarkicu,
} from "./exciseStamps.types";

const getInicijalniPodaciZaZahtevObveznika = (): Promise<
  ApiResponseObject<IInicijalniPodaciZaZahtevObveznikaProps>
> => {
  return axios.get("/inicijalniPodaciZaZahtevObveznika");
};

const postVracanjeDodatnihInformacijaZaKreiranjeZahteva = (
  payload: IInformacijeZaVracanjeMarkica
): Promise<
  ApiResponseObject<IVracanjeDodatnihInformacijaZaKreiranjeZahtevaProps>
> => {
  return axios.post("/vracanjeDodatnihInformacijaZaKreiranjeZahteva", payload);
};

const postKreiranjeZahtevaZaMarkicu = (
  payload: IKreiranjeZahtevaZaMarkicuPayload
): Promise<ApiResponseObject<{ id: number; brojZahteva: string } | null>> => {
  return axios.post("/kreiranjeZahtevaZaMarkicu", payload);
};

const putIzmeniZahtevZaMarkicu = (
  payload: IKreiranjeZahtevaZaMarkicuPayload
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/izmenaZahtevaZaMarkicu", payload);
};

const postSviZahteviZaMarkicu = (
  payload: ExciseStampRequestListPayload
): Promise<ApiResponseObject<ISviZahteviMarkiceProps>> => {
  return axios.post("/sviZahteviZaMarkicu", payload);
};

const postGenerisiZahtevZaMarkicuPdf = (
  payload: IZahtevMarkiceIdProps
): Promise<ApiResponseObject<IGenerisiZahtevZaMarkicuPdfProps>> => {
  return axios.post("/generisiZahtevZaMarkicuPdf", payload);
};

const postInformacijeNapravljenogZahtevaZaMarkicu = (
  payload: IZahtevMarkiceIdProps
): Promise<ApiResponseObject<NapravljenZahtevZaMarkicu>> => {
  return axios.post("/informacijeNapravljenogZahtevaZaMarkicu", payload);
};

const postPodaciOMarkamaProizvoda = (
  payload: IPodaciOMarkamaProizvodaPayload
): Promise<ApiResponseObject<IResultsProps>> => {
  return axios.post("/podaciOMarkamaProizvoda", payload);
};

const postMaloprodajneCeneMarkiProizvoda = (
  payload: IMaloProdajnaPayload
): Promise<ApiResponseObject<IMaloProdajnaProps>> => {
  return axios.post("/maloprodajneCeneMarkiProizvoda", payload);
};

const createStampajPredracun = (
  id: number | null
): Promise<ApiResponseObject<IStampajPredracunProps>> => {
  return axios.post("/stampajPredracun", undefined, { params: { id } });
};

const createPopuniIzvestajZaKafuIliAlkohol = (
  payload: IPopuniIzvestajZaKafuIliAlkoholPayload
): Promise<ApiResponseObject<number | null>> => {
  return axios.post("/popuniIzvestajZaKafuIliAlkohol", payload);
};

const updateIzmeniIzvestajZaKafuIliAlkohol = (
  payload: IPopuniIzvestajZaKafuIliAlkoholPayload,
  id: number | null
): Promise<ApiResponseObject<number | null>> => {
  return axios.put(`/izmeniIzvestajZaKafuIliAlkohol/${id}`, payload);
};

const getListaKategorijaZaZahtev = (
  brojZahteva: string,
  markicaKategorijeId: AkciznaMarkicaKategorijaProzivoda | null
): Promise<ApiResponseObject<Array<IKategorijaZaZahtevProps>>> => {
  return axios.get("/listaKategorijaZaZahtev", {
    params: { brojZahteva, markicaKategorijeId },
  });
};

const getMarkicaZahtevIsporuceniOpsezi = (
  brojZahteva: string,
  markicaKategorijeId: AkciznaMarkicaKategorijaProzivoda | null
): Promise<ApiResponseObject<Array<MarkicaZahtevIsporuceniOpsezi>>> => {
  return axios.get("/markicaZahtevIsporuceniOpseg", {
    params: { brojZahteva, markicaKategorijeId },
  });
};

const getEvidencijaPeriodicniIzvestaji = (): Promise<
  ApiResponseObject<Array<{ period: string; periodId: number }>>
> => {
  return axios.get("/evidencijaPeriodicniIzvestaji");
};

const downloadDocumentSpecification = ({
  documentId,
}: {
  documentId: number;
}): Promise<ApiResponseObject<{ data: string; format: string }>> => {
  return axios.post("/preuzmiDokumentSpecifikacija", undefined, {
    params: {
      dokumentId: documentId,
    },
  });
};

export const exciseStampsRepo = {
  getInicijalniPodaciZaZahtevObveznika,
  postVracanjeDodatnihInformacijaZaKreiranjeZahteva,
  postKreiranjeZahtevaZaMarkicu,
  postSviZahteviZaMarkicu,
  postGenerisiZahtevZaMarkicuPdf,
  postInformacijeNapravljenogZahtevaZaMarkicu,
  putIzmeniZahtevZaMarkicu,
  postPodaciOMarkamaProizvoda,
  postMaloprodajneCeneMarkiProizvoda,
  createStampajPredracun,
  createPopuniIzvestajZaKafuIliAlkohol,
  updateIzmeniIzvestajZaKafuIliAlkohol,
  getListaKategorijaZaZahtev,
  downloadDocumentSpecification,
  getMarkicaZahtevIsporuceniOpsezi,
  getEvidencijaPeriodicniIzvestaji,
};
